import { Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { POSITIONS_HEADER, U_KEY } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import { usePositions } from '@pages/Employees/Positions/hooks/usePositions';
import { usePositionsEffects } from '@pages/Employees/Positions/hooks/usePositionsEffects';

import { adaptDataToTable } from '@pages/Employees/Positions/utils/adaptDataToTable';

import type { FC } from 'react';

import '@pages/Employees/Positions/styles/Positions.mobile.scss';

export const Positions: FC = () => {
  const {
    isLoading,
    positions,
    handleEdit,
    isMobile,
    hasUserRightToViewPositions,
    hasUserRightToEditPosition,
    handleChange,
    pageNumber,
    rowsPerPage,
    getPositionsHandler,
  } = usePositions();

  usePositionsEffects({ getPositionsHandler });

  if (!hasUserRightToEditPosition && !hasUserRightToViewPositions) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="Positions">
      <Table
        className="Positions__table"
        rowKey={(record) => String(record[U_KEY])}
        loading={isLoading}
        columns={POSITIONS_HEADER}
        rowClassName="position-item"
        dataSource={adaptDataToTable(
          positions,
          handleEdit,
          hasUserRightToEditPosition
        )}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 500 }}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            generateSpanWithDataTestId(
              isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`,
              'pagination-info'
            ),
          pageSize: rowsPerPage,
          current: pageNumber,
          onChange: handleChange,
        }}
      />
    </div>
  );
};
